import { CardContainerController } from './cardContainer.controller';
import template from './cardContainer.html';

export const cardContainerComponent = {
  name: 'cardContainer',
  restrict: 'E',
  transclude: true,
  template,
  controller: CardContainerController,
  controllerAs: 'vm',
  bindings: {
    defaultUser: '<?'
  }
};
